import { Moon, Sun } from 'lucide-react';
import React from 'react';
import { ForgeTheme } from '../../hooks/useForgeTheme';

interface ThemeToggleProps {
  theme: ForgeTheme;
  onToggle: () => void;
  /** `sidebar` renders a footer link with a label; `topbar` renders an icon-only button. */
  variant: 'sidebar' | 'topbar';
  /** Sidebar only: the label is hidden, so the accessible name doubles as a tooltip. */
  collapsed?: boolean;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({
  theme,
  onToggle,
  variant,
  collapsed = false,
}) => {
  const next: ForgeTheme = theme === 'dark' ? 'light' : 'dark';
  const nextLabel = next === 'dark' ? 'Dark mode' : 'Light mode';
  const accessibleName = `Switch to ${nextLabel.toLowerCase()}`;
  const icon = next === 'dark' ? <Moon /> : <Sun />;

  if (variant === 'topbar') {
    return (
      <button
        type="button"
        className="forge-mobile-nav-button"
        aria-label={accessibleName}
        onClick={onToggle}
      >
        {icon}
      </button>
    );
  }

  return (
    <button
      type="button"
      className="sidebar-footer-link"
      aria-label={accessibleName}
      title={collapsed ? accessibleName : undefined}
      onClick={onToggle}
    >
      {icon}
      <span className="sidebar-collapse-label">{nextLabel}</span>
    </button>
  );
};
